{
  "loadError": "No se pudo cargar la configuración del impuesto sobre las ventas.",
  "source": {
    "own": "Se aplican las configuraciones propias de esta organización, a partir de",
    "inherited": "Se aplican las configuraciones heredadas de {{owner}}, a partir de"
  },
  "outcome": {
    "notCharged": "No se cobran el PST de BC, el RST de Manitoba y el PST de Saskatchewan",
    "chargedNow": "Actualmente se cobran el PST de BC, el RST de Manitoba y el PST de Saskatchewan",
    "basedOnOwnSetting": ", según la configuración \"Permitir cargo de PST\" en la",
    "feeSettingsPage": "Página de configuración de tarifas",
    "basedOnOwnerSetting": ", según la configuración \"Permitir cargo de PST\" de {{owner}}.",
    "setUpCallToAction": "Elija sus impuestos y guarde para configurarlo.",
    "confirmCallToAction": "Guarde para confirmar o cambiar esto."
  },
  "table": {
    "columns": {
      "province": "Provincia",
      "bcPst": "PST de BC",
      "mbRst": "RST de MB",
      "skPst": "PST de SK",
      "gst": "GST",
      "hst": "HST",
      "qst": "QST"
    },
    "alwaysCharged": "Siempre cobrado",
    "charged": "Cobrado",
    "notCharged": "No cobrado",
    "ratesNote": "Tasas actuales, mostradas como referencia. Las tasas son gestionadas por OneVest."
  },
  "readOnly": {
    "missingPermission": "Usted puede ver la configuración del impuesto sobre las ventas, pero no cambiarla."
  },
  "edit": {
    "save": "Guardar",
    "discard": "Descartar"
  },
  "dateNote": {
    "today": "Se aplica a todo el ciclo de facturación actual. Las facturas ya calculadas no cambian."
  },
  "saveDialog": {
    "title": "Guardar configuración del impuesto sobre las ventas",
    "newRevision": "Estas configuraciones entran en vigor hoy, {{date}}.",
    "correction": "Esto reemplaza las configuraciones ya guardadas para hoy, {{date}}. El original se conserva para auditoría.",
    "confirm": "Guardar",
    "cancel": "Cancelar"
  },
  "saveNotice": {
    "conflictBeforeReload": "Alguien más guardó una configuración para esta fecha mientras usted estaba editando.",
    "reload": "Recargar",
    "conflictAfterReload": "para obtener lo más reciente; sus elecciones se mantienen.",
    "reloaded": "Recargado. Sus elecciones se mantienen; revíselas y guarde de nuevo.",
    "reloadFailed": "Guardado, pero no se pudieron cargar las últimas configuraciones."
  },
  "saveError": "No se pudieron guardar las configuraciones del impuesto sobre las ventas.",
  "sync": {
    "applying": "Aplicando su cambio. Las tarifas utilizan la configuración anterior hasta que esto finalice.",
    "notReached": "Este cambio aún no ha llegado a la facturación. Las tarifas utilizan la configuración que se muestra a continuación hasta que lo haga. Si esto persiste, comuníquese con soporte.",
    "notReachedViewed": "Un cambio de herencia reciente para {{viewed}} aún no ha llegado a la facturación. Las tarifas utilizan la configuración que se muestra a continuación hasta que lo haga. Si esto persiste, comuníquese con soporte."
  },
  "inherit": {
    "label": "Heredar del padre",
    "stopped": "Se dejó de heredar. Las configuraciones propias de esta organización se aplican de nuevo (o la configuración anterior, si no se guardó ninguna).",
    "hint": {
      "unsavedChanges": "Guarde o descarte sus cambios primero",
      "missingOrganizationWrite": "Usted necesita permiso para editar la configuración de la organización para cambiar esto.",
      "missingOrganizationRead": "Usted necesita permiso para ver la configuración de la organización para cambiar esto.",
      "orgFlagUnconfirmed": "No se pudo confirmar si esta organización hereda de su padre."
    }
  }
}
